"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Escapes characters that can not be in an XML element.
 */
function escapeElement(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
}
exports.escapeElement = escapeElement;
//# sourceMappingURL=escape-element.js.map